import API from '../.';
const ENTITY = 'products/thumbnails';

export const getProductThumbnail = (id) => API.get(`/api/v1/${ENTITY}/${id}/`);
export const updateThumbnail = (data, id) =>
    API.patch(`/api/v1/${ENTITY}/${id}/`, data);
export const deleteThumbnail = (id) => API.delete(`/api/v1/${ENTITY}/${id}/`);
